import { render, staticRenderFns } from "./ThgBillingBatchNumberData.vue?vue&type=template&id=748d6c27&"
import script from "./ThgBillingBatchNumberData.vue?vue&type=script&lang=ts&"
export * from "./ThgBillingBatchNumberData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardActions,VIcon,VTextField})
